import React from 'react';
import { motion } from 'framer-motion';
import { ActivityIcon, RefreshCwIcon, AlertCircleIcon, ArrowDownCircleIcon } from 'lucide-react';
export function PainPointsSection() {
  const cards = [{
    icon: AlertCircleIcon,
    title: 'Stubborn Inflammation',
    desc: "When swelling and irritation won't subside with basic rest and ice."
  }, {
    icon: RefreshCwIcon,
    title: 'Recurring Joint or Soft-Tissue Pain',
    desc: 'Discomfort that keeps returning and interfering with daily life.'
  }, {
    icon: ActivityIcon,
    title: 'Slow Injury Recovery',
    desc: 'When strains, sprains, or sports injuries take too long to heal.'
  }, {
    icon: ArrowDownCircleIcon,
    title: 'Stiffness or Limited Movement',
    desc: 'When pain restricts your range of motion and flexibility.'
  }];
  return <section className="py-20 md:py-24 bg-white" data-id="element-207">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-14" data-id="element-209">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-brand-navy mb-5 leading-tight" data-id="element-210">
            When Pain Keeps Coming Back, It Helps to Know Your Options
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-211">
            Rest, stretching, medication, and home care may help temporarily,
            but stubborn pain and inflammation often need a more focused
            approach. Laser therapy is designed to support the body's natural
            repair process at the tissue level.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-12" data-id="element-212">
          {cards.map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-white p-7 rounded-2xl border-2 border-gray-200 text-center hover:border-brand-teal/40 hover:shadow-lg transition-all duration-300" data-id="element-213">
              <div className="w-14 h-14 mx-auto bg-brand-teal rounded-2xl flex items-center justify-center mb-5 text-white shadow-md shadow-brand-teal/20" data-id="element-214">
                <card.icon className="w-7 h-7" data-id="element-215" />
              </div>
              <h3 className="text-lg font-black text-brand-navy mb-2 leading-tight" data-id="element-216">
                {card.title}
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-217">
                {card.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-218">
          <a href="#consultation-form" className="inline-flex px-8 py-4 bg-brand-teal hover:bg-brand-teal-dark text-white rounded-lg font-bold text-base md:text-lg transition-all duration-300 items-center justify-center shadow-lg shadow-brand-teal/30" data-id="element-219">
            See If Laser Therapy Is a Fit
          </a>
        </motion.div>
      </div>
    </section>;
}